__turbopack_context__.v({
  "siteLogo": "style-module-scss-module__aP5h6q__siteLogo",
  "siteLogoFixed": "style-module-scss-module__aP5h6q__siteLogoFixed",
});
